import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { NotFound, RouteError } from '@/components/layout/RouteStatus.tsx';
import { UpdatePrompt } from '@/components/layout/UpdatePrompt.tsx';
import { Toaster } from '@/components/ui/toaster.tsx';
import { TooltipProvider } from '@/components/ui/tooltip.tsx';
import type { RouterContext } from '@/lib/route-guards.ts';

/** Root of every page: toasts, PWA update prompt, error + 404 screens. */
export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  errorComponent: RouteError,
  notFoundComponent: NotFound,
});

function RootLayout() {
  return (
    <TooltipProvider>
      <Outlet />
      <Toaster />
      <UpdatePrompt />
    </TooltipProvider>
  );
}
